import * as ReactDOM from "react-dom";
import * as data from "data";

import { routes } from "./routes";

(window as any)["data"] = data;

ReactDOM.render(routes(), document.getElementById("main-content"));
